export enum WindowEvents {
    Unload = 'unload',
    BeforeUnload = 'beforeunload',
    Load = 'load',
}
